module.exports = __webpack_public_path__ + "img/client-saigon.1f4873e3.png";